import { ReduxStore } from 'store/types';

function getAllToSelectIsLoading(state: ReduxStore): boolean {
  return state.category.getAllToSelect.config.isLoading;
}

export default getAllToSelectIsLoading;
